export default "__VITE_ASSET__3f9$r6TG__"